import { IconProps } from "./";
import Icon from "./assets/menu_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Menu(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
